import styled from '@emotion/styled';
import * as React from 'react';
import { IPAD_MEDIA, PAGE_PADDING } from '../../vars';

export interface CenterWidgetProps {
  className?: any;
  forwardRef?: React.ForwardedRef<HTMLDivElement>;
  width?: number;
}

export const PADDING = PAGE_PADDING;

export const CenterWidget: React.FC<React.PropsWithChildren<CenterWidgetProps>> = (props) => {
  return (
    <S.Container width={props.width || 900} ref={props.forwardRef} className={props.className}>
      {props.children}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div<{ width: number }>`
    margin: auto;
    width: min(calc(100vw - ${PADDING * 2}px), ${(p) => p.width}px);

    @media (max-width: ${IPAD_MEDIA}px) {
      width: auto;
      margin: 0;
      margin-left: ${PADDING}px;
      margin-right: ${PADDING}px;
    }
  `;
}
